export default "__VITE_ASSET__Dqkvm55S__"